import React, {
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import ProductSlider from "./ProductSlider";
import "../swiper.css";
import uniqid from "uniqid";


export default function Slider({
  id,
  products = [],
  theme,
  cardWidth,
  cardType,
  template
}) {



  const [uniqueId, setUniqueId] = useState(id || uniqid());
  const [slides, setSlides] = useState(products);

  useEffect(() => {
    if (products.length) {
      setSlides(products);
      global[`mySwiper_${uniqueId}`] && global[`mySwiper_${uniqueId}`].update();
    }
  }, [products]);

  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.innerHTML = `
      var mySwiper_${uniqueId} = new Swiper('#${uniqueId}', {
        slidesPerView : 1,
        direction: 'horizontal',
        centeredSlides: true,
        setWrapperSize: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
        },
        height: 400,
      });
    `;
    document.body.appendChild(script);
  }, [uniqueId]);

  return (
    <div
      className="swiper-container"
      id={uniqueId}
      style={{
        color: theme["colorAccent"],
        height: `${cardWidth ? cardWidth * 2 : 400}px`
      }}
    >
      <div
        style={{
          color: theme["colorText"]
        }}
        className="swiper-button-next"
      >
        <svg style={{ opacity: slides.length > 1 ? 0.4 : 0 }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44"><path d="M27,22L27,22L5,44l-2.1-2.1L22.8,22L2.9,2.1L5,0L27,22L27,22z" fill="currentColor" /></svg>
      </div>

      <div
        style={{
          color: theme["colorText"]
        }}
        className="swiper-button-prev"
      >
        <svg style={{ opacity: slides.length > 1 ? 0.4 : 0 }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 27 44" ><path d="M0,22L22,0l2.1,2.1L4.2,22l19.9,19.9L22,44L0,22L0,22L0,22z" fill="currentColor" /> </svg>
      </div>

      <div
        className="swiper-pagination"
        style={{
          color: theme["colorAccent"],
          opacity: slides.length > 1 ? 1 : 0
        }}
      ></div>
      <div className="swiper-wrapper">
        {products.map((oneProduct, ind) => {
          return (
            <div className="swiper-slide"
              key={`slide_${ind}`}
            >
              <ProductSlider
                theme={theme}
                template={template}
                cardWidth={cardWidth}
                {...oneProduct}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
